<div class="container v2-active">
    <div class="dialog-header">
        <h1>{{ titulo }}</h1>
        <a (click)="fechar()">
            <mat-icon>close</mat-icon>
        </a>
    </div>

    <div class="descricao" [innerHTML]="descricao"></div>

    @if (valorBase) {
        <p class="confirm-hint">{{ 'shared.confirmDialogInput.confirmLabel' | transloco }}</p>

        <div class="copy-box">
            <span class="valor-base">{{ valorBase }}</span>
            <button
                type="button"
                class="copy-btn"
                [cdkCopyToClipboard]="valorBase"
                (cdkCopyToClipboardCopied)="copiar()"
                [attr.aria-label]="'shared.codeSnippet.copy' | transloco"
            >
                <mat-icon>content_copy</mat-icon>
            </button>
        </div>

        <input
            class="confirm-input"
            [(ngModel)]="textoConfirmacao"
            [placeholder]="'shared.confirmDialogInput.placeholder' | transloco"
            autocomplete="off"
        />

        <div class="dialog-actions">
            <button mat-stroked-button color="secondary" type="button" (click)="nao()">
                {{ 'shared.confirmDialogInput.cancel' | transloco }}
            </button>
            <button
                mat-flat-button
                type="button"
                (click)="sim()"
                class="btn-confirm-yes"
                [disabled]="!isConfirmationValid"
            >
                {{ 'shared.confirmDialogInput.confirm' | transloco }}
            </button>
        </div>
    } @else {
        <div class="dialog-actions">
            <button mat-stroked-button color="secondary" type="button" (click)="nao()">
                {{ 'shared.confirmDialog.no' | transloco }}
            </button>
            <button mat-flat-button type="button" (click)="sim()" class="btn-confirm-yes">
                {{ 'shared.confirmDialog.yes' | transloco }}
            </button>
        </div>
    }
</div>
